import Vuex from 'vuex'
import Vue from 'vue'
import Cookies from 'js-cookie'
import {
    createLoginOPT,
    loginByEmail,
    postRequest
} from '../apis/front'
import { Message } from 'element-ui'
import multiAccountManager from '../utils/multiAccountManager'
import contextPotModule from './contextPot'
Vue.use(Vuex)

const store = new Vuex.Store({
    modules: {
        contextPot: contextPotModule
    },
    state: {
        user_id: Cookies.get('user_id') || multiAccountManager.getCurrentAccountId(),
        user_info: {
            user_name: Cookies.get('user_name'),
            creator_functionality_level: Cookies.get('creator_functionality_level'),
            user_avatar_address_small: Cookies.get('user_avatar_address_small'),
            user_type: Cookies.get('user_type'),
            account_type: Cookies.get('account_type') || '',
            coder_todos_enabled: Cookies.get('coder_todos_enabled') || 'NO',
            account_role: Cookies.get('account_role') || 'subscriber'
        },
        tempCollectionId: null,
        tempBundleId: null,
        // Platform subscription state (Netflix model)
        platformSubscription: null // { active, subscription, trial_eligible, is_trialing, tier }
    },
    mutations: {
        setUserId(state, user_id) {
            state.user_id = user_id
            Cookies.set('user_id', user_id)
        },
        setUserValue(state, value) {
            state.user_info = value
            Cookies.set('user_name', value.user_name)
            Cookies.set('user_avatar_address_small', value.user_avatar_address_small)
            Cookies.set('user_type', value.user_type)
            Cookies.set('account_type', value.account_type || '')
            Cookies.set('coder_todos_enabled', value.coder_todos_enabled || 'NO')
            Cookies.set('account_role', value.account_role || 'subscriber')
        },
        setUserCreatorLevel(state, value) {
            state.user_info.creator_functionality_level = value.creator_functionality_level
            Cookies.set('creator_functionality_level', value.creator_functionality_level)
        },
        setUserAvatar(state, value) {
            state.user_info.user_avatar_address_small = value
            Cookies.set('user_avatar_address_small', value)
            // Also update in the multi-account manager
            const currentAccountId = multiAccountManager.getCurrentAccountId()
            if (currentAccountId) {
                multiAccountManager.updateAccount(currentAccountId, {
                    user_avatar_address_small: value
                })
            }
        },
        setUserType(state, value) {
            state.user_info.user_type = value
            Cookies.set('user_type', value)
            // Also update in the multi-account manager
            const currentAccountId = multiAccountManager.getCurrentAccountId()
            if (currentAccountId) {
                multiAccountManager.updateAccount(currentAccountId, {
                    user_type: value
                })
            }
        },
        updateUserName(state, userName) {
            state.user_info.user_name = userName
            Cookies.set('user_name', userName)
            // Also update in the multi-account manager
            const currentAccountId = multiAccountManager.getCurrentAccountId()
            if (currentAccountId) {
                multiAccountManager.updateAccount(currentAccountId, {
                    user_name: userName
                })
            }
        },
        updateUserProfile(state, profileData) {
            // Update multiple profile fields at once
            if (profileData.user_name !== undefined) {
                state.user_info.user_name = profileData.user_name
                Cookies.set('user_name', profileData.user_name)
            }
            if (profileData.user_avatar_address_small !== undefined) {
                state.user_info.user_avatar_address_small = profileData.user_avatar_address_small
                Cookies.set('user_avatar_address_small', profileData.user_avatar_address_small)
            }
            if (profileData.user_type !== undefined) {
                state.user_info.user_type = profileData.user_type
                Cookies.set('user_type', profileData.user_type)
            }
            if (profileData.coder_todos_enabled !== undefined) {
                state.user_info.coder_todos_enabled = profileData.coder_todos_enabled || 'NO'
                Cookies.set('coder_todos_enabled', profileData.coder_todos_enabled || 'NO')
            }
            // Update in the multi-account manager
            const currentAccountId = multiAccountManager.getCurrentAccountId()
            if (currentAccountId) {
                multiAccountManager.updateAccount(currentAccountId, profileData)
            }
        },
        setAchievementStats(state, achievementStats) {
            Vue.set(state.user_info, 'achievement_stats', achievementStats)
        },
        setTempCollectionId(state, id) {
            state.tempCollectionId = id
            // Save to localStorage for persistence across page refreshes
            if (id) {
                localStorage.setItem('currentCollectionId', id)
            } else {
                localStorage.removeItem('currentCollectionId')
            }
        },
        setTempBundleId(state, id) {
            state.tempBundleId = id
        },
        // Platform subscription mutations
        setPlatformSubscription(state, data) {
            state.platformSubscription = data
        },
        clearPlatformSubscription(state) {
            state.platformSubscription = null
        }
    },
    actions: {
        createLoginOPT({ commit }, payload) {
            const email = typeof payload === 'string' ? payload : payload.student_email
            const turnstileToken = typeof payload === 'string' ? undefined : payload.turnstile_token
            return new Promise((resolve, reject) => {
                createLoginOPT(email, turnstileToken).then(response => {
                    const result = response.data
                    if (result.code === 0) {
                        resolve()
                    } else {
                        Message.error(result.msg)
                        reject(result.msg)
                    }
                }).catch(error => {
                    reject(error)
                })
            })
        },
        loginByEmail({ commit }, loginInfo) {
            return new Promise((resolve, reject) => {
                loginByEmail(loginInfo.student_email, loginInfo.opt_code).then(response => {
                    const result = response.data
                    if (result.code === 0) {
                        let data = result.data
                        let user_id = data._id.$oid || data._id.$id
                        commit('setUserId', user_id)
                        commit('setUserValue', {
                            user_name: data.user_nickName,
                            user_avatar_address_small: data.user_avatar_address_small,
                            user_type: data.user_type,
                            account_type: data.account_type || '',
                            coder_todos_enabled: data.coder_todos_enabled || 'NO',
                            account_role: data.account_role || 'subscriber'
                        })
                        commit('setUserCreatorLevel', {
                            creator_functionality_level: data.creator_functionality_level || 'Basic',
                        })

                        // Add account to multi-account manager
                        multiAccountManager.addAccount({
                            user_id: user_id,
                            user_name: data.user_nickName,
                            user_email: loginInfo.student_email,
                            user_avatar_address_small: data.user_avatar_address_small,
                            user_type: data.user_type,
                            account_type: data.account_type || '',
                            creator_functionality_level: data.creator_functionality_level || 'Basic',
                            coder_todos_enabled: data.coder_todos_enabled || 'NO',
                            account_role: data.account_role || 'subscriber'
                        })

                        resolve()
                    } else {
                        Message.error({
                          message: result.msg,
                          duration: 10000
                        })
                        reject(result.msg)
                    }
                }).catch(error => {
                    reject(error)
                })
            })
        },
        logOut({ commit }) {
            const currentAccountId = multiAccountManager.getCurrentAccountId()
            if (currentAccountId) {
                multiAccountManager.removeAccount(currentAccountId)
            }

            commit('setUserId', '')
            commit('setUserValue', {
                user_name: '',
                user_avatar_address_small: '',
                user_type: ''
            })
            commit('clearPlatformSubscription')
        },
        // Fetch platform subscription status
        async fetchPlatformSubscription({ commit, state }) {
            if (!state.user_id) return null
            try {
                const response = await postRequest('getPlatformSubscription', {
                    user_id: state.user_id
                })
                if (response.data.code === 0) {
                    commit('setPlatformSubscription', response.data.data)
                    return response.data.data
                }
            } catch (error) {
                console.error('Failed to fetch platform subscription:', error)
            }
            return null
        },
        async switchAccount({ commit }, accountId) {
            const account = multiAccountManager.getAccount(accountId)
            if (!account) throw new Error('Saved account not found')
            let switchResult
            try {
                const response = await postRequest('switchSavedAccount', {
                    target_user_id: account.user_id
                })
                switchResult = response.data
            } catch (error) {
                throw new Error('Could not switch accounts. Please try again.')
            }
            if (switchResult.code !== 0) {
                throw new Error(switchResult.msg || 'Sign in to this account before switching to it.')
            }

            const success = multiAccountManager.switchToAccount(accountId)
            if (success) {
                    // Clear editing states from previous user
                    commit('setTempCollectionId', null)
                    commit('setTempBundleId', null)
                    localStorage.removeItem('editCollectionId')
                    localStorage.removeItem('editPostId')
                    localStorage.removeItem('editBundleId')

                    // Try to fetch fresh user profile data
                    try {
                        const response = await postRequest('getUserProfile', {
                            user_id: account.user_id
                        })
                        
                        if (response.data.code === 0) {
                            const freshData = response.data.data
                            // Update the account with fresh data
                            multiAccountManager.updateAccount(accountId, {
                                user_name: freshData.user_nickName || account.user_name,
                                user_avatar_address_small: freshData.user_avatar_address_small || account.user_avatar_address_small,
                                user_type: freshData.user_type || account.user_type,
                                account_type: freshData.account_type || account.account_type || '',
                                creator_functionality_level: freshData.creator_functionality_level || account.creator_functionality_level,
                                account_role: freshData.account_role || account.account_role || 'subscriber'
                            })
                            
                            // Commit fresh data to store
                            commit('setUserId', account.user_id)
                            commit('setUserValue', {
                                user_name: freshData.user_nickName || account.user_name,
                                user_avatar_address_small: freshData.user_avatar_address_small || account.user_avatar_address_small,
                                user_type: freshData.user_type || account.user_type,
                                account_type: freshData.account_type || account.account_type || '',
                                coder_todos_enabled: freshData.coder_todos_enabled || account.coder_todos_enabled || 'NO',
                                account_role: freshData.account_role || account.account_role || 'subscriber'
                            })
                            commit('setUserCreatorLevel', {
                                creator_functionality_level: freshData.creator_functionality_level || account.creator_functionality_level
                            })
                        } else {
                            // If fetching fresh data fails, use cached data
                            commit('setUserId', account.user_id)
                            commit('setUserValue', {
                                user_name: account.user_name,
                                user_avatar_address_small: account.user_avatar_address_small,
                                user_type: account.user_type,
                                account_type: account.account_type || '',
                                account_role: account.account_role || 'subscriber'
                            })
                            commit('setUserCreatorLevel', {
                                creator_functionality_level: account.creator_functionality_level
                            })
                        }
                    } catch (error) {
                        // If API call fails, still use cached data
                        console.warn('Failed to fetch fresh user profile, using cached data:', error)
                        commit('setUserId', account.user_id)
                        commit('setUserValue', {
                            user_name: account.user_name,
                            user_avatar_address_small: account.user_avatar_address_small,
                            user_type: account.user_type,
                            account_type: account.account_type || '',
                            account_role: account.account_role || 'subscriber'
                        })
                        commit('setUserCreatorLevel', {
                            creator_functionality_level: account.creator_functionality_level
                        })
                    }
                    
                return
            }
            throw new Error('Failed to switch account')
        },
        getAllAccounts() {
            return multiAccountManager.getAllAccounts()
        },
        getCurrentAccount() {
            const currentId = multiAccountManager.getCurrentAccountId()
            return multiAccountManager.getAccount(currentId)
        },
        initializeAccount({ commit, state }) {
            const currentAccountId = multiAccountManager.getCurrentAccountId()
            if (currentAccountId && !state.user_id) {
                const account = multiAccountManager.getAccount(currentAccountId)
                if (account) {
                    multiAccountManager.switchToAccount(currentAccountId)
                    commit('setUserId', account.user_id)
                    commit('setUserValue', {
                        user_name: account.user_name,
                        user_avatar_address_small: account.user_avatar_address_small,
                        user_type: account.user_type,
                        account_type: account.account_type || '',
                        account_role: account.account_role || 'subscriber'
                    })
                    commit('setUserCreatorLevel', {
                        creator_functionality_level: account.creator_functionality_level
                    })
                }
            } else if (state.user_id) {
                // Update the account in manager if user is already logged in
                multiAccountManager.addAccount({
                    user_id: state.user_id,
                    user_name: state.user_info.user_name,
                    user_avatar_address_small: state.user_info.user_avatar_address_small,
                    user_type: state.user_info.user_type,
                    creator_functionality_level: state.user_info.creator_functionality_level,
                    account_role: state.user_info.account_role || 'subscriber',
                    account_type: state.user_info.account_type || '',
                })
            }
        },
        setTempCollectionId({ commit }, id) {
            commit('setTempCollectionId', id)
        },
        setTempBundleId({ commit }, id) {
            commit('setTempBundleId', id)
        }
    }
})

export default store
